import React from 'react';
import { Users, Heart, Plane, Briefcase } from 'lucide-react';

const FloorplanSection = ({ property }) => {
  const perfectFor = [
    { icon: Users, title: "Couples", desc: "Romantic countryside getaway" },
    { icon: Heart, title: "Honeymooners", desc: "Intimate & secluded retreat" },
    { icon: Plane, title: "Travellers", desc: "15 mins from Gatwick Airport" },
    { icon: Briefcase, title: "Remote Workers", desc: "Fast WiFi & peaceful setting" }
  ];

  return (
    <section className="py-10 md:py-16 px-4 md:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          
          {/* Left - Floorplan */}
          <div className="animate-fade-in">
            <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-3 md:mb-4" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>
              The Space
            </h2>
            <p className="text-muted-foreground mb-4 md:mb-6 text-sm md:text-base">
              A thoughtfully designed open-plan layout with everything you need for the perfect escape.
            </p>
            <div className="bg-card rounded-xl md:rounded-2xl p-3 md:p-4 shadow-md border border-border/50">
              <img 
                src={property.floorplan} 
                alt="The Hayloft Floorplan" 
                className="w-full h-auto rounded-lg md:rounded-xl"
              />
            </div>
          </div>

          {/* Right - Perfect For */}
          <div className="animate-fade-in-up animation-delay-200">
            <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-3 md:mb-4" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>
              Perfect For
            </h2>
            <p className="text-muted-foreground mb-4 md:mb-6 text-sm md:text-base">
              The Hayloft is ideal for those seeking tranquility, comfort, and a taste of the English countryside.
            </p>
            
            <div className="space-y-3 md:space-y-4">
              {perfectFor.map((item, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-card rounded-xl border border-border/50 hover:shadow-md transition-shadow"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <item.icon className="w-5 h-5 md:w-6 md:h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground text-sm md:text-base">{item.title}</h3>
                    <p className="text-xs md:text-sm text-muted-foreground">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default FloorplanSection;
